import { ACTION_DETAILS } from "models/role/action";
import { SUBJECT_CASH_MANAGEMENT } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";
import { accountRoutes } from "./account";
import { providerCustomerConfigRoutes } from "./providerCustomerConfig";

import type { Route } from "routes/RouteModel";

const CashManagement = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagement" */
      "../pages/Details"
    ),
  "CashManagement"
);
const NotificationsSettingsEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementNotifications" */
      "../pages/NotificationsSettingsEdit"
    ),
  "CashManagementNotifications"
);

export const cashManagementRoutes: Route[] = [
  {
    i18nName: "Cash management",
    path: PAGE_URLS.details,
    component: CashManagement,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT,
    },
  },
  ...accountRoutes,
  ...providerCustomerConfigRoutes,
  {
    i18nName: "Edit notifications settings - Cash management",
    path: PAGE_URLS.notifications,
    component: NotificationsSettingsEdit,
  },
];
